import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { BookMarked, Search } from "lucide-react";
import { GLOSSARY } from "../../lib/printGlossary";
import { Panel, field } from "./_ui";

export function Glossary() {
  const [q, setQ] = useState("");
  const [letter, setLetter] = useState("");
  const letters = useMemo(() => [...new Set(GLOSSARY.map(([t]) => t[0].toUpperCase()))].sort(), []);
  const list = useMemo(() => {
    const n = q.trim().toLowerCase();
    return GLOSSARY.filter(([t, d]) => (!n || t.toLowerCase().includes(n) || d.toLowerCase().includes(n)) && (!letter || t[0].toUpperCase() === letter)).sort((a, b) => a[0].localeCompare(b[0]));
  }, [q, letter]);

  return (
    <Panel icon={BookMarked} title={`Print glossary — ${GLOSSARY.length} terms`} testId="print-glossary">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <div className="relative max-w-xs flex-1 min-w-[12rem]">
          <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-white/40" />
          <input value={q} onChange={(e) => { setQ(e.target.value); setLetter(""); }} className={`${field} pl-8`} placeholder="Search a term…" data-testid="glossary-search" />
        </div>
        <div className="flex flex-wrap gap-1" data-testid="glossary-letters">
          <button type="button" onClick={() => setLetter("")} className={`w-7 h-7 font-mono text-xs border border-white/15 ${!letter ? "bg-[#B87333]" : "bg-black/30 text-white/70"}`}>All</button>
          {letters.map((l) => <button key={l} type="button" onClick={() => { setLetter(l); setQ(""); }} className={`w-7 h-7 font-mono text-xs border border-white/15 ${letter === l ? "bg-[#B87333]" : "bg-black/30 text-white/70 hover:text-white"}`} data-testid={`glossary-letter-${l}`}>{l}</button>)}
        </div>
      </div>
      <dl className="grid md:grid-cols-2 gap-x-8 gap-y-3" data-testid="glossary-list">
        {list.map(([term, def, href]) => (
          <div key={term} id={`term-${term.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="border-b border-white/10 pb-2">
            <dt className="font-display font-bold text-[#E8B587]">{term}</dt>
            <dd className="text-sm text-white/80 mt-0.5">{def}{href && <> <Link to={href} className="font-mono text-[10px] tracking-widest uppercase text-white/60 hover:text-white ml-1">Learn more →</Link></>}</dd>
          </div>
        ))}
        {list.length === 0 && <div className="text-sm text-white/70">No term matches "{q}".</div>}
      </dl>
    </Panel>
  );
}
